<div
  (click)="onCancel.emit()"
  aria-labelledby="modal-title"
  aria-modal="true"
  class="fixed inset-0 bg-black/50 flex items-center justify-center z-50"
  role="dialog"
>
  <div
    (click)="$event.stopPropagation()"
    class="bg-white rounded w-full max-w-4xl max-h-[90vh] flex flex-col shadow-lg"
  >
    <!-- header -->
    <header
      class="rounded px-4 py-3 border-b border-gris-3 sticky top-0 bg-white z-10 flex items-center gap-2"
    >
      <span class="material-icons text-vert-1">route</span>
      <h2 id="modal-title" class="text-lg font-semibold">
        {{ 'delivery_round.optimize.preview.title' | translate }}
      </h2>
    </header>

    <!-- contenu -->
    <div class="p-4 overflow-auto flex-1 flex flex-col gap-3">
      <!-- Résumé des tournées -->
      <div class="flex flex-wrap gap-2">
        @for (route of preview().routes; track route.round_id) {
          <div
            class="flex flex-col gap-0.5 px-3 py-2 border border-gris-3 rounded text-xs"
          >
            <span class="font-semibold">{{ route.round_name }}</span>
            <span class="fg-gris-1">
              {{ 'delivery_round.optimize.preview.distance' | translate }} :
              {{ formatDistance(route.distance) }} —
              {{ 'delivery_round.optimize.preview.duration' | translate }} :
              {{ formatDuration(route.duration) }}
            </span>
          </div>
        }
      </div>

      <!-- Carte -->
      <div
        #mapContainer
        class="w-full h-96 rounded border border-gris-3 overflow-hidden"
      ></div>
    </div>

    <!-- footer -->
    <footer
      class="rounded px-4 py-3 border-t sticky bottom-0 border-gris-3 bg-white z-10 flex justify-end gap-2"
    >
      <app-button-cta
        (onClick)="onCancel.emit()"
        iconType="material_outlined"
        label="common.cancel"
        svgName="chevron_left"
      />
      <app-button-cta
        (onClick)="onConfirm.emit()"
        [active]="true"
        iconType="material_outlined"
        label="common.confirm"
        svgName="check_circle"
        type="green"
      />
    </footer>
  </div>
</div>
